import update from "immutability-helper";

import {
  SS_UPDATE_ACTIVE_QUERY,
  SS_UPDATE_MAILING_LIST_ID,
  SS_UPDATE_ALL_ORGANIZATIONS,
  SS_SUBMIT_QUERY_START,
  SS_SUBMIT_QUERY_FAILURE,
  SS_SUBMIT_QUERY_SUCCESS,
} from "../actions/subscriber_search.js";

export default (state = {}, action) => {
  switch (action.type) {
    case SS_UPDATE_ACTIVE_QUERY:
      return update(state, { activeQuery: { $set: action.activeQuery } });
    case SS_UPDATE_MAILING_LIST_ID:
      return update(state, { mailingListID: { $set: action.id } });
    case SS_UPDATE_ALL_ORGANIZATIONS:
      if (action.value) {
        return update(state, {
          $merge: { allOrganizations: true, mailingListID: 0 },
        });
      } else {
        return update(state, { $merge: { allOrganizations: false } });
      }
    case SS_SUBMIT_QUERY_START:
      return update(state, {
        $merge: {
          subscribersFound: null,
          loading: true,
          error: null,
        },
      });
    case SS_SUBMIT_QUERY_FAILURE:
      return update(state, {
        $merge: {
          subscribersFound: null,
          loading: false,
          error: action.error,
        },
      });
    case SS_SUBMIT_QUERY_SUCCESS:
      return update(state, {
        $merge: {
          subscribersFound: action.subscribers,
          suppressionFound: action.suppression,
          loading: false,
          query: action.query,
        },
      });
    default:
      return state;
  }
};
